import '../../boot'
import './index.scss'
import { createApp, ref } from 'vue/dist/vue.esm-bundler'
import { NButton, NFormItem, NForm, NCard, NDatePicker } from 'naive-ui'
import AppLayoutMixin from "@/app-layout-mixin";
import EmbedCode from "@/components/embed";


createApp({
    components: { NButton, NFormItem, NForm, NCard, NDatePicker, EmbedCode },
    mixins: [ AppLayoutMixin ],
    setup() {
        return {
            startDate: ref(Date.now() - 1684684000),
            endDate: ref(Date.now())
        }
    },
    computed: {
        diffInSeconds() {
            return Math.floor((this.endDate - this.startDate) / 1000);
        },
        days() {
            return Math.floor(this.diffInSeconds / 60 / 60 / 24);
        },
        hours() {
            return Math.floor(this.diffInSeconds / 60 / 60) - this.days*24;
        },
        minutes() {
            return Math.floor(this.diffInSeconds / 60 ) - this.days*60*24 - this.hours*60;
        },
        seconds() {
            return Math.floor(this.diffInSeconds - this.days*60*60*24 - this.hours*60*60 - this.minutes*60);
        },
        result() {
            const result = [];
            if (this.days) {
                result.push(this.days + ' days');
            }
            if (this.hours) {
                result.push(this.hours + ' hours');
            }
            if (this.minutes) {
                result.push(this.minutes + ' minutes');
            }
            if (this.seconds) {
                result.push(this.seconds + ' seconds');
            }
            return result.join(', ');
        },
        onlyYears() {
            return Math.floor(this.diffInSeconds / 60 / 60 / 24 / 365);
        },
        onlyWeeks() {
            return Math.floor(this.diffInSeconds / 60 / 60 / 24 / 7);
        },
        onlyDays() {
            return Math.floor(this.diffInSeconds / 60 / 60 / 24);
        },
        onlyHours() {
            return Math.floor(this.diffInSeconds / 60 / 60);
        },
        onlyMinutes() {
            return Math.floor(this.diffInSeconds / 60 );
        },
        onlySeconds() {
            return this.diffInSeconds;
        },
    }
}).mount('#app')
